import { isMobile, isTablet } from "react-device-detect";
import { useTranslation } from "react-i18next";
import FormLoginComponent from "./form-login";
import "./index.scss";

interface IProps {
  isModal?: boolean;
  isRedirect?: boolean;
  closeLoginModal?: () => void;
}

function WrapLoginFormComponent({
  isModal,
  isRedirect,
  closeLoginModal,
}: IProps) {
  const { t } = useTranslation();

  return (
    <div
      className={
        isMobile
          ? `wrap-login-form-mobile ${isTablet ? "shadow" : ""}`
          : "wrap-login-form"
      }
      style={
        isTablet
          ? { paddingBottom: 0, width: "88%", margin: "auto", marginTop: 100 }
          : {}
      }
    >
      <div
        className={`${isModal ? "" : "box-reservation-shadow"} box-top${
          isModal ? "-modal" : ""
        }`}
      >
        <div
          className="text-header"
          style={isTablet ? { marginBottom: 15, marginTop: 20 } : {}}
        >
          {t("hotel_reservation.text_header_form_login")}
        </div>
        <FormLoginComponent
          closeLoginModal={closeLoginModal}
          isRedirect={isRedirect}
        />
      </div>
    </div>
  );
}

export default WrapLoginFormComponent;
